import {
  BG_STYLES,
  Button,
  BUTTON_TYPE,
  COMMON_STYLES,
  LazyImage,
  SIZE,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import React from 'react'
import { StyleSheet, View, Text, StyleProp, ViewStyle } from 'react-native'

import ProductIcon from '../../icons/ProductIcon'
import TickIcon from '../../icons/Tick'


interface Props {
  name: string
  imageUrl: string | null
  isSelected: boolean
  onCTAClick: () => void
  style?: StyleProp<ViewStyle>
}

const ProductCard = ({
  name,
  imageUrl,
  isSelected,
  onCTAClick,
  style,
}: Props) => {
  return (
    <View
      style={[
        COMMON_STYLES['p1/2'],
        styles.productCard,
        BG_STYLES.bgNeutral10,
        COMMON_STYLES.alignItemsCenter,
        style,
      ]}
    >
      <LazyImage
        imageUrl={imageUrl}
        imgStyles={styles.img104X104}
        fallBackIcon={<ProductIcon height={104} width={104} />}
      />

      <View
        style={[
          COMMON_STYLES.fullWidth,
          COMMON_STYLES.alignItemsCenter,
          COMMON_STYLES.justifyCenter,
          COMMON_STYLES['ph1/2'],
          COMMON_STYLES['pv1/2'],
        ]}
      >
        <Text
          style={[
            TYPOGRAPHY.TEXT2,
            VARIANTS_STYLES.MEDIUM,
            TEXT_STYLES.textNeutral90,
          ]}
          numberOfLines={1}
        >
          {name}
        </Text>
      </View>
      <Button
        onClick={onCTAClick}
        text={isSelected ? 'Selected' : 'Select'}
        size={SIZE.small}
        buttonStyle={COMMON_STYLES.fullWidth}
        type={isSelected ? BUTTON_TYPE.SECONDARY : BUTTON_TYPE.PRIMARY}
        iconLeft={isSelected && <TickIcon />}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  productCard: {
    width: 144,
    height: 192,
    borderRadius: 8,
  },
  img104X104: {
    height: 104,
    width: '100%',
  },
})

export default ProductCard
